import store from 'shared/store';
import { initFormKitSchema } from 'shared/utils/initFormKitSchema';
import { createApp, defineAsyncComponent } from 'vue';
import FitTool from "./FitTool.vue";
import FitToolResult from "./FitToolResult.vue";
import "./fitTool.scss";

const fitTool = document.getElementById('fit-tool');
	if (fitTool) {
		const app = createApp({
			name: 'FitToolApp',
		});
		app.component('fit-tool', FitTool);
		app.component('fit-tool-result', FitToolResult);
		app.component('fit-tool-carousel', defineAsyncComponent(
			() => import('./FitToolCarousel.vue')
		));
		app.component('product-highlights-block', defineAsyncComponent(
			() => import('shared/components/ProductHighlights/ProductHighlightsBlock.vue')
		));
		app.component('highlighted-multimedia-block', defineAsyncComponent(
			() => import('shared/components/mediaItems/HighlightedMultimediaBlock.vue')
		));
		app.component('video-poster', defineAsyncComponent(
			() => import('shared/components/VideoElements/videoPoster.vue')
		));
		app.component('related-content-block', defineAsyncComponent(
			() => import('shared/components/contentLibrary/relatedContentBlock.vue')
		));
		app.component('content-recommended-block', defineAsyncComponent(
			() => import('shared/components/contentLibrary/contentRecommendedBlock.vue')
		));
		app.component('cta-block', defineAsyncComponent(
			() => import('shared/components/articleElements/ctaBlock.vue')
		));
		app.component('cta-button-with-popup-form', defineAsyncComponent(
			() => import('shared/components/actionButtonWithCTA/CtaButtonWithPopupForm.vue')
		));
		app.component('form-kit-builder-container', defineAsyncComponent(
			() => import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue')
		));
		initFormKitSchema(app);
		app.use(store);
		app.mount(fitTool);
	}
